import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';
export const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: themes.light.modalBackground[1],
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    width: '90%',
    backgroundColor: themes.light.white[1],
    borderRadius: 10,
    position: 'relative',
  },
  icon: {
    width: 16,
    height: 16,
  },
  closeButton: {
    position: 'absolute',
    top: 16,
    right: 16,
    zIndex: 1,
  },
  title: {
    textAlign: 'center',
    marginBottom: 16,
  },
  content: {
    padding: 16,
  },
});
